import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b2118f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "d-flex justify-content-between",
  style: {"padding-top":"15px","font-size":"16px"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_3 = {
  class: "table align-middle table-row-dashed fs-6 table-hover",
  id: "table_accounts_requests"
}
const _hoisted_4 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Sales UID", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Target UID", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Rebate", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Alpha", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Pro", -1))
const _hoisted_10 = {
  key: 0,
  style: {"height":"300px"}
}
const _hoisted_11 = { colspan: "12" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { colspan: "12" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 0,
  class: "fa-solid fa-triangle-exclamation me-2",
  style: {"color":"red"}
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))

import { ref, computed, inject } from "vue";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import { Search } from "@element-plus/icons-vue";
import BalanceShow from "@/components/BalanceShow.vue";
import TimeShow from "@/components/TimeShow.vue";
import SchemaDetail from "./SalesRebateSchemaDetail.vue";
import SchemaNote from "./SalesRebateSchemaNote.vue";
import RebateService from "../services/RebateService";
import { salesTypeOptions } from "@/core/types/SalesTypes";


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesRebateSchemaCard',
  props: {
    items: {},
    isLoading: { type: Boolean }
  },
  emits: ["refresh", "hasError"],
  setup(__props: any, { emit: emits }) {

const props = __props;

const accountSelected = ref(0);
const SchemaNoteRef = ref<any>(null);
const SchemaDetailRef = ref<any>(null);





const dotClass = ref({
  0: "text-success",
  1: "text-primary",
  2: "text-danger",
  3: "text-info",
  4: "text-warning",
  5: "text-secondary",
});

const scheduleType = ref({
  0: "D",
  1: "P",
  3: "M",
});

let totalRebate = computed(() => {
  let total = props.items.reduce((total, item) => total + item.rebate, 0);

  if (
    total >
    salesTypeOptions.find((option) => option.value === props.items[0].salesType)
      ?.rebate
  ) {
    emits("hasError");
  }

  return total;
});

let totalAlpha = computed(() => {
  let total = props.items.reduce((total, item) => total + item.alphaRebate, 0);

  if (
    total >
    salesTypeOptions.find((option) => option.value === props.items[0].salesType)
      ?.alphaRebate
  ) {
    emits("hasError");
  }
  return total;
});

let totalPro = computed(() => {
  let total = props.items.reduce((total, item) => total + item.proRebate, 0);

  if (
    total >
    salesTypeOptions.find((option) => option.value === props.items[0].salesType)
      ?.proRebate
  ) {
    emits("hasError");
  }
  return total;
});

const deleteSchema = async (item: any) => {
  try {
    await RebateService.deleteSalesRebateSchema(item.id);
    emits("refresh");
  } catch (error) {
    console.log(error);
  }
};

const approve = async (item: any) => {
  try {
    await RebateService.putSalesRebateSchemaStatus(item.id);
    emits("refresh");
  } catch (e) {
    console.log(e);
  }
};

const selectedAccount = (id: number) => {
  if (accountSelected.value == id) {
    accountSelected.value = 0;
    return;
  }
  accountSelected.value = id;
};

const showSchemaDetail = (_item: any) => {
  SchemaDetailRef.value.show(_item);
};

const showSchemaNote = (_item: any) => {
  SchemaNoteRef.value.show(_item);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, _toDisplayString(props.items[0].salesName) + " - " + _toDisplayString(props.items[0].salesCode), 1),
      _createElementVNode("div", null, _toDisplayString(_unref(salesTypeOptions).find(
          (option) => option.value === props.items[0].salesType
        )?.label), 1)
    ]),
    _hoisted_2,
    _createElementVNode("table", _hoisted_3, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _hoisted_9,
          _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.note")), 1),
          _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.operator")), 1),
          _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.action")), 1)
        ])
      ]),
      (props.isLoading)
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_11, [
                _createVNode(ScaleLoader)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (!props.isLoading && props.items.length === 0)
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.$t("tip.nodata")), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (!props.isLoading && props.items.length != 0)
        ? (_openBlock(), _createBlock(_TransitionGroup, {
            key: 2,
            tag: "tbody",
            name: "table-delete-fade",
            class: "table-delete-fade-container text-gray-600 fw-semibold"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item,
                  class: _normalizeClass({
          'account-select': item.id === accountSelected.value,
          'waiting-approve': item.status,
        }),
                  onClick: ($event: any) => (selectedAccount(item.id))
                }, [
                  _createElementVNode("td", null, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fa-solid fa-circle-notch me-2", dotClass.value[item.salesType % 6]])
                    }, null, 2),
                    _createTextVNode(_toDisplayString(item.salesAccountUid), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["me-2", dotClass.value[item.schedule % 6]])
                    }, _toDisplayString(scheduleType.value[item.schedule]), 3),
                    _createTextVNode(_toDisplayString(item.rebateAccountUid), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(BalanceShow, {
                      balance: item.rebate
                    }, null, 8, ["balance"])
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(BalanceShow, {
                      balance: item.alphaRebate
                    }, null, 8, ["balance"])
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(BalanceShow, {
                      balance: item.proRebate
                    }, null, 8, ["balance"])
                  ]),
                  _createElementVNode("td", {
                    onClick: ($event: any) => (showSchemaNote(item))
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fa-regular fa-comment-dots", { 'text-secondary': item.note == '' }])
                    }, null, 2)
                  ], 8, _hoisted_15),
                  _createElementVNode("td", null, _toDisplayString(item.operatorFirstName), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("button", {
                      class: "btn btn-light btn-success btn-sm me-3",
                      onClick: ($event: any) => (showSchemaDetail(item))
                    }, _toDisplayString(_ctx.$t("title.details")), 9, _hoisted_16),
                    (item.status == -1)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-light btn-danger btn-sm me-3",
                          onClick: ($event: any) => (deleteSchema(item))
                        }, _toDisplayString(_ctx.$t("action.delete")), 9, _hoisted_17))
                      : _createCommentVNode("", true),
                    (item.status == -1 && _ctx.$can('SuperAdmin'))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "btn btn-light btn-warning btn-sm me-3",
                          onClick: ($event: any) => (approve(item))
                        }, " Approve ", 8, _hoisted_18))
                      : _createCommentVNode("", true)
                  ])
                ], 10, _hoisted_14))
              }), 128)),
              _createElementVNode("tr", {
                key: "card-total",
                class: _normalizeClass({
          'total-error':
            _unref(totalRebate) >
              _unref(salesTypeOptions).find(
                (option) => option.value === props.items[0].salesType
              )?.rebate ||
            _unref(totalAlpha) >
              _unref(salesTypeOptions).find(
                (option) => option.value === props.items[0].salesType
              )?.alphaRebate ||
            _unref(totalPro) >
              _unref(salesTypeOptions).find(
                (option) => option.value === props.items[0].salesType
              )?.proRebate,
        })
              }, [
                _createElementVNode("td", null, [
                  (
              _unref(totalRebate) >
                _unref(salesTypeOptions).find(
                  (option) => option.value === props.items[0].salesType
                )?.rebate ||
              _unref(totalAlpha) >
                _unref(salesTypeOptions).find(
                  (option) => option.value === props.items[0].salesType
                )?.alphaRebate ||
              _unref(totalPro) >
                _unref(salesTypeOptions).find(
                  (option) => option.value === props.items[0].salesType
                )?.proRebate
            )
                    ? (_openBlock(), _createElementBlock("i", _hoisted_19))
                    : _createCommentVNode("", true),
                  _createTextVNode("Total ")
                ]),
                _hoisted_20,
                _createElementVNode("td", null, [
                  _createVNode(BalanceShow, { balance: _unref(totalRebate) }, null, 8, ["balance"])
                ]),
                _createElementVNode("td", null, [
                  _createVNode(BalanceShow, { balance: _unref(totalAlpha) }, null, 8, ["balance"])
                ]),
                _createElementVNode("td", null, [
                  _createVNode(BalanceShow, { balance: _unref(totalPro) }, null, 8, ["balance"])
                ]),
                _hoisted_21,
                _hoisted_22
              ], 2)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(SchemaDetail, {
      ref_key: "SchemaDetailRef",
      ref: SchemaDetailRef,
      onRefresh: _cache[0] || (_cache[0] = ($event: any) => (emits('refresh')))
    }, null, 512),
    _createVNode(SchemaNote, {
      ref_key: "SchemaNoteRef",
      ref: SchemaNoteRef
    }, null, 512)
  ], 64))
}
}

})